import React from 'react';
import TipForm from '../shared/tip-form';
import globalStyles from '../../utility/styles';

const style = {
  box: {
    marginLeft: '20%',
    marginRight: '20%'
  }
};


const TipCreationPage = (props) => {
  return (
    <div>
      <h1 style={globalStyles.header}>Create Tip</h1>
      <div style={style.box}>
        <TipForm {...props}/>
      </div>
    </div>
  )
}

export default TipCreationPage;


// WEBPACK FOOTER //
// ./src/screens/create-tip/index.js